export const ANIMATION_FRAME_TIMES = {
  LOOP_START: 0,
  LOOP_END: 55,
  ANIMATION_END: 119,
};
